import React from 'react';
import { Link } from '@tanstack/react-router';
import viri from '../../assets/img/viri.png';
import { useI18n } from '../../i18n/context';

/**
 * Footer component.
 *
 * Displays site branding, navigation links organized by category, and social media icons.
 * Includes copyright notice with current year.
 *
 * @module components/Footer
 * @category Components
 * @returns {React.ReactElement} Footer element
 */
function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useI18n();

  const footerLinks = [
    {
      title: t('footer.company'),
      links: [
          { name: t('footer.contactUs'), to: '/contact' },
        { name: t('footer.about'), to: '/about' },
        { name: t('footer.blog'), to: 'https://blog.stealthisnft.xyz' },
      ]
    },
    {
      title: t('footer.resources'),
      links: [
        { name: t('footer.acknowledgements'), to: '/acknowledgements' },
        { name: t('footer.physicalGoods'), to: '/physical-goods' },
        { name: t('footer.faq'), to: '/faq' },
          { name: t('footer.t3Group'), to: 'https://txt3.com' },
      ]
    },
    {
      title: t('footer.legal'),
      links: [
        { name: t('footer.terms'), to: '/terms' },
        { name: t('footer.privacy'), to: '/privacy-policy' },
        { name: t('footer.dmca'), to: '/dmca' },
      ]
    },
  ];

  return (
      <>
      <div style={{height: "15px"}}></div>
    <footer className="footer mt-auto py-3" style={{
      backgroundColor: '#1a1a2e',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)'
    }}>
      <div className="container-fluid">
        <div className="row align-items-start">
          {/* Logo and Brand */}
          <div className="col-lg-3 col-md-6 mb-3 mb-md-0">
            <div className="d-flex align-items-center">
              <img
                src={viri}
                alt="Viri"
                style={{ height: '32px', marginRight: '10px' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <span className="text-white fw-bold fs-5">Viri NFT Market</span>
            </div>
            <p className="text-secondary mt-2 mb-0 small">
              {t('footer.description')}
            </p>
            <p className="text-secondary small mb-0" style={{ marginTop: '8px' }}>
              {t('footer.copyright', { year: currentYear })}
            </p>
          </div>

          {/* Links Columns */}
          {footerLinks.map((section, idx) => (
            <div key={idx} className="col-lg-2 col-md-6 mb-3 mb-md-0">
              <h6 className="text-white text-uppercase fw-bold mb-2" style={{ fontSize: '0.78rem', letterSpacing: '0.5px' }}>
                {section.title}
              </h6>
              <ul className="list-unstyled">
                {section.links.map((link, linkIdx) => (
                  <li key={linkIdx} className="mb-0">
                    <Link
                      to={link.to}
                      className="text-secondary text-decoration-none"
                      style={{ fontSize: '0.88rem', lineHeight: '1.0', transition: 'color 0.2s', cursor: 'pointer' }}
                      onMouseEnter={(e) => e.target.style.color = '#ffffff'}
                      onMouseLeave={(e) => e.target.style.color = '#adb5bd'}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Social Links */}
          <div className="col-lg-3 col-md-12 mb-3 mb-md-0 text-md-end">
            <h6 className="text-white text-uppercase fw-bold mb-2" style={{ fontSize: '0.78rem', letterSpacing: '0.5px' }}>
              {t('footer.connect')}
            </h6>
            <div className="d-flex justify-content-md-end gap-3">
              <a
                href="#"
                className="text-secondary"
                style={{ fontSize: '1.2rem', transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.target.style.color = '#7928CA'}
                onMouseLeave={(e) => e.target.style.color = '#adb5bd'}
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="#"
                className="text-secondary"
                style={{ fontSize: '1.2rem', transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.target.style.color = '#7928CA'}
                onMouseLeave={(e) => e.target.style.color = '#adb5bd'}
              >
                <i className="fab fa-discord"></i>
              </a>
              <a
                href="#"
                className="text-secondary"
                style={{ fontSize: '1.2rem', transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.target.style.color = '#7928CA'}
                onMouseLeave={(e) => e.target.style.color = '#adb5bd'}
              >
                <i className="fab fa-github"></i>
              </a>
              <a
                href="#"
                className="text-secondary"
                style={{ fontSize: '1.2rem', transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.target.style.color = '#7928CA'}
                onMouseLeave={(e) => e.target.style.color = '#adb5bd'}
              >
                <i className="fab fa-telegram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
          </>
  );
}

export default Footer;
